import { AlertTriangle, CheckCircle2, FilePenLine, RefreshCcw } from 'lucide-react'
import type { Document } from '@agentwiki/shared'
import { cn } from '../../lib/utils'
import { getDocumentKindInfo } from '../../lib/document-kind'

const iconByKind = {
  verified: CheckCircle2,
  stale: RefreshCcw,
  conflict: AlertTriangle,
  draft: FilePenLine,
}

export function DocumentStatusBadge({
  doc,
  compact = false,
  className,
}: {
  doc?: Pick<Document, 'sourceProvenance'> | null
  compact?: boolean
  className?: string
}) {
  const info = getDocumentKindInfo(doc)
  const Icon = iconByKind[info.kind]

  return (
    <span className={cn('aw-doc-status-badge', `is-${info.kind}`, compact && 'compact', className)}>
      <Icon className="h-3.5 w-3.5" />
      {compact ? info.shortLabel : info.label}
    </span>
  )
}
